import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import Spinner from 'shared/components/Spinner';
import { OAUTH } from 'shared/constants';
import { userportal, createUserportalLink } from 'shared/routes';
import { selectors } from 'userportal/ducks/auth';
import Page from 'userportal/components/Page';

const Request = () => {
  const { t } = useTranslation('userportal');
  const navigate = useNavigate();
  const loggedIn = useSelector(selectors.isLoggedIn);

  useEffect(() => {
    if (!loggedIn) {
      const state = window.crypto.randomUUID().replace(/-/g, '');
      localStorage.setItem(OAUTH.LINKEDIN.STATE_KEY, state);

      const params = {
        response_type: 'code',
        client_id: OAUTH.LINKEDIN.CLIENT_ID,
        redirect_uri: createUserportalLink(userportal.oauth.linkedIn.callbackUrl),
        state,
        scope: 'r_liteprofile%20r_emailaddress'
      };

      const qs = Object.entries(params).map(([key, value]) => `${key}=${value}`).join('&');
      window.location = `https://www.linkedin.com/oauth/v2/authorization?${qs}`;
    }
  }, []);

  useEffect(() => {
    if (loggedIn) {
      navigate(userportal.root, { replace: true });
    }
  }, [loggedIn]);

  return (
    <Page relative={false}>
      <Spinner splash>{t('page.oauth.inProgress')}</Spinner>
    </Page>
  );
};

export default Request;
